import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCircleFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.5354 8.38136L10.5856 13.3311L8.46431 11.2098C8.07379 10.8193 7.44063 10.8193 7.0501 11.2098C6.65958 11.6003 6.65958 12.2335 7.0501 12.624L9.80782 15.3817C10.2374 15.8113 10.9339 15.8113 11.3635 15.3817L16.9496 9.79557C17.3401 9.40505 17.3401 8.77188 16.9496 8.38136C16.5591 7.99083 15.9259 7.99083 15.5354 8.38136Z" })
});
export default SvgCheckCircleFill;
